export default "__VITE_ASSET__CkmrmzPj__"